export default __webpack_public_path__ + "static/media/slide4.66bb2831.webp";